import commonNav from '@/components/common-nav/index.vue';
import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	register: 'register',
};
const {
	mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.register);
export default {
	data() {
		return {
			mobile: '',
			password: '',
			surePsd: '',
			captcha: '',
			postCaptcha: '',
			isClickFlag: true,
			captchaText: '获取验证码',
			captchaResText: '重新获取',
			time: 60,
			fromType: 'register',
		};
	},
	async mounted() {
		const getParam = this.$route.query;
		this.fromType = getParam?getParam.type : this.fromType;
	},
	components: {
		'common-nav': commonNav
	},
	watch: {
	
	},
	computed: {
		...mapState({
			
		}),
		headTitle(){
			return this.fromType === 'register'?'注册' : '找回密码';
		}
	},
	methods: {
		...mapActions({
			getCaptcha: 'getCaptcha',
			postRegister: 'postRegister',
			postChangePwd: 'postChangePwd'
		}),
		mobileInput(){
			const len = this.mobile.length;
			if(len > 11){
				this.$refs.mobile.value = this.mobile = this.mobile.substring(0,11);
			}
		},
		async captchaHandle(){
			if(!this.mobile){
				common.toast('请输入手机号。', 'error');
				return;
			}
			if(this.isClickFlag){
				const text = this.captchaText;
				const time = this.time;
				const param = {
					content: this,
					data: {
						mobile: this.mobile,
						type: this.fromType
					}
				};
				const getCaptchaData = await this.getCaptcha(param);
				if (getCaptchaData && getCaptchaData.code == 1) {
					// this.postCaptcha = getCaptchaData.data;
					this.isClickFlag = false;
					this.captchaText = `${this.captchaResText}(${this.time}s)`;
					const Timer = setInterval(()=>{
						if(this.time <= 0){
							this.captchaText = text;
							this.time = time;
							this.isClickFlag = true;
							clearInterval(Timer)
						}else{
							this.time--;
							this.captchaText = `${this.captchaResText}(${this.time}s)`;
						}
					},1000);
				}
			}
		},
		submit(){
			const isEmptyflag = this.mobile && this.password && this.surePsd && this.captcha?true : false;
			const isFlag1 = /^(?![^a-zA-Z]+$)(?!\D+$)/.test(this.password);//密码至少包含一个数字和一个字母
			const isFlag2 = /([0-9a-zA-Z])\1{5}/.test(this.password);//密码不允许连续六位的重复数字和字母
			if(!isEmptyflag){
				common.toast('请完整填写注册信息。', 'error');
				return;
			}
			if(this.password !== this.surePsd){
				common.toast('两次输入的密码不一致。', 'error');
				return;
			}
			if(this.password.length <= 8){
				common.toast('密码长度至少8位以上。', 'error');
				return;
			}
			if(!isFlag1){
				common.toast('密码至少包含一个数字和一个字母。', 'error');
				return;
			}
			if(isFlag2){
				common.toast('密码不允许连续六位的重复数字和字母。', 'error');
				return;
			}
			if(this.fromType === 'register'){
				/* 注册 */
				this.postRegisterHandle();
			}else if(this.fromType === 'password'){
				/* 找回密码 */
				this.postChangePwdHandle();
			}
		},
		async postRegisterHandle(){
			const param = {
				content: this,
				data: {
					mobile: this.mobile,
					password: this.password,
					captcha: this.captcha
				}
			};
			const getRegisterData = await this.postRegister(param);
			console.log(getRegisterData)
			if(getRegisterData && getRegisterData.code == 1){
				common.toast(getRegisterData.msg, 'success',()=>{
					common.goBack(this);
				});
			}
		},
		async postChangePwdHandle(){
			const param = {
				content: this,
				data: {
					mobile: this.mobile,
					password: this.password,
					captcha: this.captcha
				}
			};
			const getChangePwdData = await this.postChangePwd(param);
			console.log(getChangePwdData)
			if(getChangePwdData && getChangePwdData.code == 1){
				common.toast(getChangePwdData.msg, 'success',()=>{
					common.Cookie().removeAll('loginData');
					common.goBack(this);
				});
			}
		}
	}
}